import util from '@utils/util';
import error from '../common/error';
import api from '../js/api';
import logreg from '../js/logreg';
import toast from '../common/toast';
import passwordInput from '../common/password';
import verificateInput from '../common/verificate';
import codeInput from '../common/code';
export default {
  name: 'phoneForget',
  props: {
    loginName: {
      type: String,
      default: ''
    },
    itc: {
      type: String,
      default: ''
    },
    country: {
      type: String,
      default: ''
    },
    wayType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      password: '',
      code: '',
      phoneCode: '',
      codeError: '',
      passwordError: '',
      token: '',
      count: 60,
      countState: false,
      act: false,
      cover: false,
      verificated: false,
      toastState: false,
      txt: '',
      imgCode: '',
      imgCodeError: ''
    };
  },
  components: {
    'error-tip': error,
    'toast-pop': toast,
    'password-input': passwordInput,
    'verificate-input': verificateInput,
    'code-input': codeInput
  },
  methods: {
    changeImgCodeHandle: function changeImgCodeHandle(code) {
      this.imgCode = code;
    },
    changeImgCodeErrorHandle: function changeImgCodeErrorHandle(txt) {
      this.imgCodeError = txt;
    },
    changeCodeErrorHandle: function changeCodeErrorHandle(txt) {
      this.codeError = txt;
    },
    changeCodeHandle: function changeCodeHandle(code) {
      this.code = code;
    },
    changePasswordHandle: function changePasswordHandle(password) {
      this.password = password;
    },
    changePasswordErrorHandle: function changePasswordErrorHandle(txt) {
      this.passwordError = txt;
    },
    changeImgCodeValueHandle: function changeImgCodeValueHandle() {
      this.$refs.imgcodeinput.getVerify();
    },
    selectWay: function selectWay(type) {
      this.$emit('selectWay', type);
    },
    verificateCode: function verificateCode() {
      var _this = this;
      if (this.code && !this.codeError && !this.cover) {
        this.cover = true;
        api.checkFgtCode(this.loginName, this.code).then(function (data) {
          _this.cover = false;
          if (data.ret === '1') {
            // 验证码发送成功
            _this.verificated = true;
            _this.token = data.access_token;
          } else {
            _this.codeError = _this.$t(_this.$loginLangPrefix('userSign.codeError'));
          }
        }).catch(function (response) {
          _this.cover = false;
          if (response.errorMessageTMXTip) {
            return;
          }
          _this.codeError = _this.$t(_this.$loginLangPrefix('userSign.sysError'));
        });
      }
    },
    send: function send() {
      var _this2 = this;
      // this.token accessToken, pwd
      if (this.password && !this.passwordError && !this.cover) {
        this.cover = true;
        var loading = util.loadingFunc();
        api.resetPwd(this.token, this.password).then(function (data) {
          if (data.ret === '1') {
            // 验证码发送成功
            logreg.userInfo(_this2.token, logreg.REGTYPE.phone, 0, function (state, udata) {
              _this2.cover = false;
              try {
                loading.hide();
              } catch (e) {
                console.log(e);
              }
              if (state === 'success') {
                _this2.$emit('success', udata);
              } else if (window.errorMessageLoginTip && window.errorMessageLoginTip.indexOf("".concat(udata.status)) >= 0 || window.errorMessageLoginTip && window.errorMessageLoginTip.indexOf(udata.data && "".concat(udata.data.status)) >= 0) {
                // this.showPop(this.$t(this.$loginLangPrefix('userSign.fkError')));
              } else if (data.errorMessageTMXTip) {
                //
              } else {
                // 重置失败
                _this2.showPop(_this2.$t(_this2.$loginLangPrefix('userSign.sysError')));
              }
            }, _this2.loginName);
          } else {
            _this2.cover = false;
            try {
              loading.hide();
            } catch (e) {
              console.log(e);
            }
            // 重置失败
            _this2.showPop(_this2.$t(_this2.$loginLangPrefix('userSign.sysError')));
          }
        }).catch(function (response) {
          _this2.cover = false;
          try {
            loading.hide();
          } catch (e) {
            console.log(e);
          }
          // 重置失败
          if (response.errorMessageTMXTip) {
            return;
          }
          _this2.showPop(_this2.$t(_this2.$loginLangPrefix('userSign.sysError')));
        });
      }
    },
    showPop: function showPop(txt, callback) {
      var _this3 = this;
      this.txt = txt;
      this.toastState = true;
      setTimeout(function () {
        _this3.txt = '';
        _this3.toastState = false;
        callback && callback();
      }, 1500);
    }
  },
  beforeMount: function beforeMount() {
    var reg = new RegExp(this.itc, 'i');
    this.phoneCode = this.loginName.replace(reg, '');
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};